import { Stack, Typography, useTheme } from "@mui/material";
import type { FC } from "react";
import { Routing } from "web_myplann/Infrastructure/Routing/Routing";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { PortfolioAddItemCategoryList } from "web_myplann/Portfolio/Components/PortfolioAddItemCategoryList";
import { useNavigatePortfolioAddItem } from "web_myplann/Portfolio/Hooks/useNavigatePortfolioAddItem";
import { PORTFOLIO_ADD_ITEM_SECTIONS } from "web_myplann/Portfolio/Types/PortfolioAddItemTypes";
import { MyPlannLayout } from "web_myplann/Shared/Header/MyPlannLayout";
import NavigationHeader from "web_myplann/Shared/Header/NavigationHeader";

export const PortfolioAddItemPage: FC = () => {
	const theme = useTheme();
	const { t } = useResource();
	const navigatePortfolioAddItem = useNavigatePortfolioAddItem();

	return (
		<MyPlannLayout
			disableContentPadding
			topBar={
				<NavigationHeader
					title={t(Resources.Portfolio.AddItem.title)}
					defaultRoute={Routing.Portfolio.PortfolioList}
				/>
			}
		>
			<Stack gap={2} pb={2.4} pt={2}>
				{PORTFOLIO_ADD_ITEM_SECTIONS.map((section) => (
					<Stack key={section.id} gap={0.8}>
						<Typography
							px={1.6}
							fontSize={12}
							fontWeight={600}
							letterSpacing="0.05em"
							textTransform="uppercase"
							color={theme.palette.grey[400]}
						>
							{t(section.labelKey)}
						</Typography>
						<PortfolioAddItemCategoryList
							items={section.items}
							onItemClick={navigatePortfolioAddItem}
						/>
					</Stack>
				))}
			</Stack>
		</MyPlannLayout>
	);
};
